module.exports = __webpack_public_path__ + "img/sLongX3_193x205.a9912352.png";